export default function () {
  const page = document.querySelector(
    '.PageMain--client-education-library, .PageMain--article-client-education-library'
  )

  if (page) {
    const form = page.querySelector('form')

    if (!form) {
      return
    }

    const selects = Array.from(page.querySelectorAll('form select.postFilter'))

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        form.submit()
      })
    })
  }
}
